import React from "react";
import { observer } from "mobx-react";
import { PermissionCreateStore } from "../../store";
import { PermissionCreateForm } from "./PermissionCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PermissionCreateProps = {
  permissionCreateStore: PermissionCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PermissionCreate: React.FC<PermissionCreateProps> = observer(
  ({ permissionCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={permissionCreateStore.isSaving} />
        <PermissionCreateForm
          permissionCreateStore={permissionCreateStore}
          name_esError={permissionCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            permissionCreateStore.setName_esValue(value);
          }}
          name_es={permissionCreateStore.entityValues.name_es}
          name_enError={permissionCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            permissionCreateStore.setName_enValue(value);
          }}
          name_en={permissionCreateStore.entityValues.name_en}
          name_ptError={permissionCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            permissionCreateStore.setName_ptValue(value);
          }}
          name_pt={permissionCreateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={permissionCreateStore.isProcessing}
          onSave={() => permissionCreateStore.saveNewPermission()}
          onCancel={() => permissionCreateStore.cancelNewPermission()}
        />
        <ErrorDialog
          open={permissionCreateStore.errorDialogOpened}
          title={permissionCreateStore.errorTitle}
          description={permissionCreateStore.errorDescription}
          onClose={() => permissionCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
